import React from "react";
import styled from "styled-components";

interface QuoteProps {
  large?: boolean;
  textColor?: string;
  market?: string;
  children: any;
}

const Quote = styled.blockquote<QuoteProps>`
  position: relative;
  font-family: ${props => props.market && 
    ["urban", "veilance"].includes(props.market.toLowerCase())
      ? '"Suisse Intl Regular", arial, sans-serif'
      : 'var(--font-helvetica)'};
  color: ${props => props.textColor};
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  line-height: 1.2rem;
  padding-left: 2.5rem;
  max-width: 500px;
`;


const Blockquote: React.FC<QuoteProps> = ({
  large = false,
  textColor = "var(--colour-black)",
  market = "outdoor",
  ...props}) => (
    // @ts-ignore
    <Quote {...props}>&quot;{props.children}&quot;</Quote>
  )
;

export default Blockquote;
